import { useState } from "react";
import { PhoneInput } from "../inputs/PhoneInput";
import { TextAreaInput } from "../inputs/TextAreaInput";
import { TextInput } from "../inputs/TextInput";
import { validateName, validatePhone } from "../validation";
import { PersonalInfoCheckbox } from "../inputs/Checkbox";

interface GuestInputsProps {
    guestName: string;
    setGuestName: (value: string) => void;
    guestPhone: string;
    setGuestPhone: (value: string) => void;
    guestNote: string;
    setGuestNote: (value: string) => void;
    isStageDone: boolean;
    setIsStageDone: (value: boolean) => void;
    createReserve: () => void;
    serverError: string;
    formColor: string;
    dataProcessingAllowed: boolean;
    setDataProcessingAllowed: (value: React.SetStateAction<boolean>) => void;
}

export const GuestInputs: React.FC<GuestInputsProps> = (props) => {
    const { guestName, setGuestName, guestPhone, setGuestPhone, guestNote, setGuestNote, setIsStageDone, createReserve, serverError, formColor, dataProcessingAllowed, setDataProcessingAllowed} = props;
    const [isFailed, setIsFailed] = useState(false);

    const reserveCreatedAction = () => {
    
        window.parent.postMessage(
        {
            type: 'RESERVE_CREATED',
            payload: { }
        },
        );
    
    };

    const tryCreateReserve = () => {
        if(!validatePhone(guestPhone) && !validateName(guestName) && dataProcessingAllowed)
        {
            setIsStageDone(true);
            createReserve();
            reserveCreatedAction();
        } else {
            setIsFailed(true);
        }
    };

    return (
        <div className={`picker__container`} >
            <div className='picker__slide'>
            <div className="picker__inputs">
                <TextInput isNotValid={isFailed ? validateName(guestName) != undefined : false} name="Имя гостя" placeholder="Имя гостя" value={guestName} setValue={setGuestName} />
                <span className='popup-reserve__validation-span'>{isFailed ? validateName(guestName) : ''}</span>
                <PhoneInput isNotValid={isFailed ? validatePhone(guestPhone) != undefined : false} name="Номер телефона" placeholder={'+7(***)***-**-**'} value={guestPhone} setValue={setGuestPhone} />
                <span className='popup-reserve__validation-span'>{isFailed ? validatePhone(guestPhone) : ''}</span>
                <TextAreaInput name="Пожелания" placeholder="Пожелания" value={guestNote} setValue={setGuestNote} />
                <span className='popup-reserve__validation-span'></span>
                <PersonalInfoCheckbox color={formColor} value={dataProcessingAllowed} setValue={setDataProcessingAllowed} />
                <span className='popup-reserve__validation-span'>{isFailed ? !dataProcessingAllowed ? 'Необходимо дать согласие на обработку персональных данных' : '' : ''}</span>
                <div style={{backgroundColor: formColor}} role='presentation' onClick={tryCreateReserve} className="picker__sendform">Создать бронирование</div>
                <span className="span-error">{serverError}</span>
            </div>
            </div>

        </div>);
}